var map = {
	"./animation_aichou.png": "7a20",
	"./animation_bainian.png": "45f0",
	"./animation_baoquan.png": "5c81",
	"./animation_haixiu.png": "ee5d",
	"./animation_huanhu.png": "3444",
	"./animation_kaixin.png": "cb4e",
	"./animation_shengqi.png": "e972"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) { // check for number or string
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return id;
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "07a0";